import { fetchTransferDownloadLink } from '../api/transfer';

import { TRANSFER_STATES } from '@app/transfer-bundle/constant/transfer-states';

function validateData({ transfer, secret, fileIds }) {
  if (!transfer.id) {
    throw new Error('InvalidTransfer');
  }

  if (
    transfer.state !== TRANSFER_STATES.DOWNLOADABLE &&
    transfer.state !== TRANSFER_STATES.DOWNLOADING &&
    transfer.state !== TRANSFER_STATES.FINISHED
  ) {
    throw new Error('TransferNotDownloadable');
  }

  if (!secret) {
    throw new Error('MissingSecret');
  }

  if (
    fileIds &&
    !fileIds.every((fileId) => transfer.items.find(({ id }) => id === fileId))
  ) {
    throw new Error('InvalidTransfer');
  }
}

function executeDownload({ downloadLink, uploadInProgress }) {
  if (!downloadLink) {
    throw new Error('DownloadFailed');
  }

  if (uploadInProgress) {
    const link = window.open(downloadLink.direct_link);
    if (link) {
      link.opener = null;
    }

    return link;
  }

  return document.location.assign(downloadLink.direct_link);
}

export async function download({
  transfer,
  secret,
  recipientId,
  fileIds,
  domainUserId,
  uploadInProgress,
}) {
  validateData({ transfer, secret, fileIds });

  const downloadLink = await fetchTransferDownloadLink({
    transferId: transfer.id,
    secret,
    recipientId,
    fileIds,
    password: transfer.password,
    domainUserId,
  });

  executeDownload({ downloadLink, uploadInProgress });
}
